
import React from "react";
import Navbar from "./Navbar";

const Header = () => {
  return (
    <div className="bg-primary ">
      <Navbar />
    </div>
  );
};

export default Header;
